import { ILinkedAccountModel, IUserModel, IUserProfileModel } from '@Shared/models';

export const REQUEST_LINKED_ACCOUNTS = 'REQUEST_LINKED_ACCOUNTS';
export const RECEIVE_LINKED_ACCOUNTS = 'RECEIVE_LINKED_ACCOUNTS';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';

export class UpdateUser {
  readonly type = UPDATE_USER;
  payload: Partial<IUserModel>;

  constructor(user: Partial<IUserModel>) {
    this.payload = user;
  }
}

export class UpdateUserProfile {
  readonly type = UPDATE_USER_PROFILE;
  payload: Partial<IUserProfileModel>;

  constructor(userProfile: Partial<IUserProfileModel>) {
    this.payload = userProfile;
  }
}

export class RequestLinkedAccounts {
  readonly type = REQUEST_LINKED_ACCOUNTS;
}

export class ReceiveLinkedAccounts {
  readonly type = RECEIVE_LINKED_ACCOUNTS;
  constructor(public linkedAccounts: ILinkedAccountModel[]) {}
}

export type CurrentUserAction = UpdateUser | UpdateUserProfile | ReceiveLinkedAccounts | RequestLinkedAccounts;
